"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const web_ui_features_1 = require("@gruposantander/web-ui-features");
const constants_1 = require("./constants");
const variant = window.COUNTRY;
const projectId = 'mb-ui';
const dynamicLoadManual = new web_ui_features_1.DynamicLoadManualManagerComponents(new web_ui_features_1.DynamicLoadManualStaticComponents(variant, projectId), {});
const renderComponent = (componentName, domElement) => {
    window.globals[constants_1.CROSS_COMPONENTS_NAME][constants_1.COMPONENTS_CONFIG][componentName].renderComponent(domElement);
};
const ComponentContainer = ({ componentName }) => {
    const [loaded, setLoaded] = react_1.default.useState(false);
    const ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const loadVertical = async () => {
            await dynamicLoadManual.loadVertical(constants_1.CROSS_COMPONENTS_NAME);
            setLoaded(true);
        };
        loadVertical();
    }, []);
    (0, react_1.useEffect)(() => {
        if (loaded) {
            renderComponent(componentName, ref.current);
        }
    }, [loaded]);
    return (0, jsx_runtime_1.jsx)("div", { ref: ref });
};
exports.ComponentContainer = ComponentContainer;
//# sourceMappingURL=ComponentContainer.js.map